import NewCarrierCard from "./Cards/NewCarrierCard";
import NewOfficeCard from "./Cards/NewOfficeCard";
import NewAgreementCard from "./Cards/NewAgreementCard";
import NewProducerCodeCard from "./Cards/NewProducerCodeCard";
import NewDigitalAssetsCard from "./Cards/NewDigitalAssetsCard";
import NewBusinessLicensesCard from "./Cards/NewBusinessLicensesCard";
import NewScorecardsCard from "./Cards/NewScorecardsCard";
import NewLeasedEquipmentCard from "./Cards/NewLeasedEquipmentCard";
import NewSecurityCard from "./Cards/NewSecurityCard";
import NewVendorCard from "./Cards/NewVendorCard";
import OfficeHierarchyCard from "./Cards/OfficeHierarchyCard";
import NewVendorInvoiceCard from "./Cards/NewVendorInvoiceCard";
import BusinessLicenseCard from "./Cards/BusinessLicenseCard";
import CarrierCard from "./Cards/CarrierCard";
import OfficeSettingsCard from "./Cards/OfficeSettingsCard";
import CarrierAgreementCard from "./Cards/CarrierAgreementCard";
import ProducerCodeCard from "./Cards/ProducerCode";
import VendorChart from "./Charts/VendorChart";
import WelcomePage from "./WelcomePage";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../Login/atoms/AccountAtom";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import RecentActivity from "./RecentActivities";
import CustomLoader from "../../components/CustomLoader";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from "chart.js";
import AgreementsChart from "./Charts/AgreementsChart";
import EmployeeChart from "./Charts/EmployeeChart";
import OfficeStatusChart from "./Charts/OfficeStatusChart";
import ProducerCodeChart from "./Charts/ProducerCodeChart";
import SideCards from "./Cards/SideCards";
import { RedirectTo } from "../../routes/RedirectTo";
import { mainSelectedTab, permittedTabs } from "../CarrierAgreementMgmt/atoms";
import { useHistory } from "react-router-dom";
import VendorInvoiceChart from "./Charts/VendorInvoiceChart";
import OfficeChart from "./Charts/OfficeStatusChart";
import CarrierChart from "./Charts/CarrierChart";
import useGetIsAdmin from "../Login/hooks/useGetIsAdmin";
import { useEffect } from "react";
import { useMutation } from "react-query";
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const history = useHistory();
  const user = useRecoilValue(accountAtom);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { mutateAsync: getIsAdmin } = useGetIsAdmin();
  const { mutate } = useMutation(() => getIsAdmin(), {
    onSuccess: (res) => {
      localStorage.setItem("admin", res.data);
    },
    onError: (error) => {
      localStorage.setItem("admin", false);
    },
  });

  useEffect(() => {
    mutate();
  }, [user]);

  return (
    <div
      className={` ${
        user.rolePermissions && user.rolePermissions.length === 0
          ? "py-6 sm:px-0 lg:px-0"
          : ""
      },
        overflow-hidden `}
    >
      {!user.userName || !user.emailAddress ? (
        <CustomLoader />
      ) : user?.rolePermissions?.length > 0 && user?.isActive ? (
        <div className="bg-tabColor pt-2">
          <div className="bg-LightWhite py-4 px-8">
            {/* Left card welcome and charts */}

            <div className="flex justify-between">
              <div className="z-20 relative text-primary">
                <h1 className="mb-2 font-bold text-primary text-xl ">
                  Welcome Back,{" "}
                  <p className="inline-block text-hsecondary font-bold welcomeFont text-xl ">
                    {`${user.firstName}`}!
                  </p>
                </h1>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-2 my-2">
              <div className="col-span-3 gap-4 sm:grid-rows-4 space-y-3">
                <NewCarrierCard />
                <NewAgreementCard />
                <NewProducerCodeCard />
                <NewOfficeCard />
              </div>
              <div className="border border-bg-gray-100 grid col-span-6 bg-white shadow-sm py-2 px-4 rounded-lg">
                <OfficeChart />
              </div>
              <div className="border border-bg-gray-100 col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg">
                <AgreementsChart />
              </div>
            </div>
            {/* Charts */}
            <div className="grid grid-cols-7 gap-2 my-4">
              <div className="col-span-1">
                <NewDigitalAssetsCard />
              </div>
              <div className="col-span-1">
                <NewBusinessLicensesCard />
              </div>
              <div className="col-span-1">
                <NewScorecardsCard />
              </div>
              <div className="col-span-1">
                <NewLeasedEquipmentCard />
              </div>
              <div className="col-span-1">
                <NewSecurityCard />
              </div>
              <div className="col-span-1">
                <NewVendorCard />
              </div>
              {/* <div className="col-span-1">
                <OfficeHierarchyCard />
              </div> */}
              <div className="col-span-1">
                <NewVendorInvoiceCard />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-2 my-2 ">
              <div className="border border-bg-gray-100 col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg ">
                <EmployeeChart />
              </div>
              {/* <div className="border border-bg-gray-100 col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg ">
                <CarrierChart />
              </div> */}
              <div className="border border-bg-gray-100 col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg">
                <VendorChart />
              </div>
              <div className="border border-bg-gray-100 col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg ">
                <VendorInvoiceChart />
              </div>
              <div className="border border-bg-gray-100 grid col-span-3 bg-white shadow-sm py-2 px-4 rounded-lg">
                <RecentActivity />
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      ) : user.rolePermissions.length === 0 ? (
        <WelcomePage />
      ) : (
        <WelcomePage />
      )}
    </div>
  );
};

export default Dashboard;
